module.exports = __webpack_public_path__ + "img/client.80ea4aab.svg";